import{ useState, useEffect } from "react";
import { config } from ".";

const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = config.BREAKPOINT;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return { width, breakpoint };
}

export default useViewport;
